import { render, staticRenderFns } from "./AIManage.vue?vue&type=template&id=3457f88d&scoped=true&"
import script from "./AIManage.vue?vue&type=script&lang=js&"
export * from "./AIManage.vue?vue&type=script&lang=js&"
import style0 from "./AIManage.vue?vue&type=style&index=0&id=3457f88d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3457f88d",
  null
  
)

export default component.exports